<template>
    <div class="container">
      <div class="faq d-flex">
        <div class="faq__banner">
            <div class="faq__banner-title text-medium d-flex">Що ще важливо знати <span>👉</span></div>
            <div class="faq__banner-title-sub">Поширені запитання
              <img src="./../assets/images/faq/faq.png" class="faq__banner-img" alt="Faq">
            </div>
          </div>
        <badger-accordion class="faq__accordion accordion-custom  w100" id="accordion">
          <badger-accordion-item class="faq__accordion-item">
            <template slot="header" class="w100" >
              <div class="faq__accordion-item-head position-relative cursor-pointer text-medium js-badger-accordion-header">Як будуть обиратись учасники Гранд Пікніка? <svg class="faq__accordion-item-icon position-absolute" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05297 0.613144L0.932969 6.73314C0.412969 7.25314 0.412969 8.09314 0.932969 8.61314C1.45297 9.13314 2.29297 9.13314 2.81297 8.61314L7.99964 3.43981L13.173 8.61314C13.693 9.13314 14.533 9.13314 15.053 8.61314C15.573 8.09314 15.573 7.25314 15.053 6.73314L8.93297 0.613144C8.4263 0.0931446 7.57297 0.0931446 7.05297 0.613144Z" fill="#202124" fill-opacity="0.54"/>
              </svg>
              </div>
            </template>
            <tempalte slot="content">
              <div class="faq__accordion-item-content">
                <div class="faq__accordion-item-text">
                  На свято потраплять 4700 співробітників, які отримають найбільшу кількість балів у межах нашого голосування.
                  Коли ти номінуєш колегу або себе, ти виставляєш від 1 до 5 балів за три категорії. Таким чином, за одне голосування співробітник може отримати від 3 до 15 балів.
                </div>
              </div>
            </tempalte>
          </badger-accordion-item>
          <badger-accordion-item class="faq__accordion-item">
            <template slot="header">
              <div class="faq__accordion-item-head position-relative cursor-pointer text-medium">Як дізнатися, хто йде на свято? <svg class="faq__accordion-item-icon position-absolute" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05297 0.613144L0.932969 6.73314C0.412969 7.25314 0.412969 8.09314 0.932969 8.61314C1.45297 9.13314 2.29297 9.13314 2.81297 8.61314L7.99964 3.43981L13.173 8.61314C13.693 9.13314 14.533 9.13314 15.053 8.61314C15.573 8.09314 15.573 7.25314 15.053 6.73314L8.93297 0.613144C8.4263 0.0931446 7.57297 0.0931446 7.05297 0.613144Z" fill="#202124" fill-opacity="0.54"/>
              </svg>
              </div>
            </template>
            <template slot="content">
              <div class="faq__accordion-item-content">
                <div class="faq__accordion-item-text">
                  Проміжні результати можна перевірити в <router-link to="/winners" class="faq__accordion-item-text-link">таблиці номінантів</router-link>. Але май на увазі, що вона постійно оновлюється :)
                  Після закінчення голосування щасливчики отримають лист-запрошення на робочу пошту
                </div>
              </div>
            </template>
          </badger-accordion-item>
          <badger-accordion-item class="faq__accordion-item">
            <template slot="header" >
              <div class="faq__accordion-item-head position-relative cursor-pointer text-medium">Як бути з тими, хто не з Києва? <svg class="faq__accordion-item-icon position-absolute" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05297 0.613144L0.932969 6.73314C0.412969 7.25314 0.412969 8.09314 0.932969 8.61314C1.45297 9.13314 2.29297 9.13314 2.81297 8.61314L7.99964 3.43981L13.173 8.61314C13.693 9.13314 14.533 9.13314 15.053 8.61314C15.573 8.09314 15.573 7.25314 15.053 6.73314L8.93297 0.613144C8.4263 0.0931446 7.57297 0.0931446 7.05297 0.613144Z" fill="#202124" fill-opacity="0.54"/>
              </svg>
              </div>
            </template>
            <template slot="content">
              <div class="faq__accordion-item-content">
                <div class="faq__accordion-item-text">
                  Не хвилюйся, ми організуємо для всіх зручний трансфер до Києва та поселення після свята. Тому сміливо номінуй колег з будь-якого куточка України!
                </div>
              </div>
            </template>
          </badger-accordion-item>
          <badger-accordion-item class="faq__accordion-item">
            <template slot="header">
              <div class="faq__accordion-item-head position-relative cursor-pointer text-medium">Можна номінувати себе? <svg class="faq__accordion-item-icon position-absolute " width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05297 0.613144L0.932969 6.73314C0.412969 7.25314 0.412969 8.09314 0.932969 8.61314C1.45297 9.13314 2.29297 9.13314 2.81297 8.61314L7.99964 3.43981L13.173 8.61314C13.693 9.13314 14.533 9.13314 15.053 8.61314C15.573 8.09314 15.573 7.25314 15.053 6.73314L8.93297 0.613144C8.4263 0.0931446 7.57297 0.0931446 7.05297 0.613144Z" fill="#202124" fill-opacity="0.54"/>
              </svg>
              </div>
            </template>
            <template slot="content">
              <div class="faq__accordion-item-content">
                <div class="faq__accordion-item-text">
                  Звісно! Себе також можна номінувати максимум 5 разів
                </div>
              </div>
            </template>
          </badger-accordion-item>
          <badger-accordion-item class="faq__accordion-item">
            <template slot="header">
              <div class="faq__accordion-item-head position-relative cursor-pointer text-medium">Як довго триває номінування? <svg class="faq__accordion-item-icon position-absolute" width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.05297 0.613144L0.932969 6.73314C0.412969 7.25314 0.412969 8.09314 0.932969 8.61314C1.45297 9.13314 2.29297 9.13314 2.81297 8.61314L7.99964 3.43981L13.173 8.61314C13.693 9.13314 14.533 9.13314 15.053 8.61314C15.573 8.09314 15.573 7.25314 15.053 6.73314L8.93297 0.613144C8.4263 0.0931446 7.57297 0.0931446 7.05297 0.613144Z" fill="#202124" fill-opacity="0.54"/>
              </svg>
              </div>
            </template>
            <template slot="content">
              <div class="faq__accordion-item-content">
                <div class="faq__accordion-item-text">
                  Номінувати можна до 15 липня включно. Тому не зволікай )
                </div>
              </div>
            </template>
          </badger-accordion-item>
        </badger-accordion>
      </div>
    </div>
</template>

<script>


import {BadgerAccordion, BadgerAccordionItem} from 'vue-badger-accordion';

export default {
  name: 'Faq',
  components: {
    BadgerAccordion,
    BadgerAccordionItem
  }
}
</script>
<style scoped lang="scss">
@use 'sass:math';
@import '../assets/styles/parts/variables';
@import '../assets/styles/parts/mixins';

.container {
    @media (max-width: 1023px) {
      padding-left: 0;
      padding-right: 0;
    }
}

.faq {
  flex-direction: column;
  @include _1024 {
    flex-direction: row;
  }
  &__banner {
    background: #FBFBFD;
    padding: sm(32) sm(24);
    @include _1024 {
      padding: sl(56) sl(56) 0;
      width: sl(459);
      border-radius: sl(24);
    }
    @include _1920 {
      width: 459px;
      padding: 56px 56px 0;
      border-radius: 24px;
    }
    &-title {
      font-size: sm(24);
      padding-bottom: sm(16);
      span {
        transform: rotate(90deg);
      }
      @include _1024 {
        font-size: sl(32);
        padding-bottom: sl(24);
        span {
          transform: rotate(0deg);
        }
      }
      @include _1920 {
        font-size: 32px;
        padding-bottom: 24px;
      }
      &-sub {
        font-size: sm(16);
        color: $text-gray;
        @include _1024 {
          font-size: sl(24);
        }
        @include _1920 {
          font-size: 24px;
        }
      }
    }
    &-img {
      display: none;
      object-position: center;
      object-fit: contain;
      @include _1024 {
        display: block;
        margin: sl(73) auto 0;
      }
      @include _1920 {
        margin: 73px auto 0;
      }
    }
  }
  &__accordion {
    @include _1024 {
      width: sl(1026);
      margin-left: auto;
    }
    @include _1920 {
      width: 1026px;
    }
    &-item {
      border-bottom: 1px solid $border-gray;
      &-icon {
        width: sm(11.17);
        height: sm(6.59);
        top: sm(30);
        right: sm(33);
        transition: transform 0.2s linear;
        transform: rotate(180deg);
        .-ba-is-active &{
          transform: rotate(0);
        }
        @include _1024 {
          width: sl(14.9);
          height: sl(8.78);
          top: sl(33);
          right: sl(32);
        }
        @include _1920 {
          width: 14.9px;
          height: 8.78px;
          top: 33px;
          right: 32px;
        }

      }

      &-head {
        padding: sm(24) sm(56) sm(24) sm(24);
        color: $text-default;
        @include _1024 {
          padding: sl(28) sl(88) sl(28) sl(32);
        }
        @include _1920 {
          padding: 28px 88px 28px 32px;
        }
      }

      &-text {
        padding: sm(16) sm(24);
        font-size: sm(18);
        @include _1024 {
          padding: sl(16) sl(32);
          font-size: sl(18);
        }
        @include _1920 {
          font-size: 18px;
          padding: 16px 32px;
        }
        &-link {
          color: #2BA2EE;
        }
      }
    }


  }
}



</style>
